export default function getUniqueObjectsFromArrayById<T extends { id: string }>(arr: T[]): T[] {
  const seenIds = new Set<string>();

  return arr.filter((element) => {
    if (!seenIds.has(element.id)) {
      seenIds.add(element.id);
      return true;
    }
    return false;
  });
}
